// extracted by mini-css-extract-plugin
export default {"accessDenied":"disabled_accessDenied__7Lz2g","disabledText":"disabled_disabledText__dmxB9","disabledTextContainer":"disabled_disabledTextContainer__KnQFO"};